const BANKS_ENUM = {
  '000': '000 - Banco não informado',
  '001': '001 - BCO DO BRASIL S.A.',
  '003': '003 - BCO DA AMAZONIA S.A.',
  '004': '004 - BCO DO NORDESTE DO BRASIL S.A.',
  '007': '007 - BNDES',
  '010': '010 - CREDICOAMO',
  '011': '011 - C.SUISSE HEDGING-GRIFFO CV S/A',
  '012': '012 - BANCO INBURSA',
  '014': '014 - STATE STREET BR S.A. BCO COMERCIAL',
  '015': '015 - UBS BRASIL CCTVM S.A.',
  '016': '016 - CCM DESP TRÂNS SC E RS',
  '017': '017 - BNY MELLON BCO S.A.',
  '018': '018 - BCO TRICURY S.A.',
  '021': '021 - BCO BANESTES S.A.',
  '024': '024 - BCO BANDEPE S.A.',
  '025': '025 - BCO ALFA S.A.',
  '029': '029 - BANCO ITAÚ CONSIGNADO S.A.',
  '033': '033 - BCO SANTANDER (BRASIL) S.A.',
  '036': '036 - BCO BBI S.A.',
  '037': '037 - BCO DO EST. DO PA S.A.',
  '040': '040 - BCO CARGILL S.A.',
  '041': '041 - BCO DO ESTADO DO RS S.A.',
  '047': '047 - BCO DO EST. DE SE S.A.',
  '060': '060 - CONFIDENCE CC S.A.',
  '062': '062 - HIPERCARD BM S.A.',
  '063': '063 - BANCO BRADESCARD',
  '064': '064 - GOLDMAN SACHS DO BRASIL BM S.A',
  '065': '065 - BCO ANDBANK S.A.',
  '066': '066 - BCO MORGAN STANLEY S.A.',
  '069': '069 - BCO CREFISA S.A.',
  '070': '070 - BRB - BCO DE BRASILIA S.A.',
  '074': '074 - BCO. J.SAFRA S.A.',
  '075': '075 - BCO ABN AMRO S.A.',
  '076': '076 - BCO KDB BRASIL S.A.',
  '077': '077 - BANCO INTER',
  '078': '078 - HAITONG BI DO BRASIL S.A.',
  '079': '079 - BCO ORIGINAL DO AGRO S/A',
  '080': '080 - B&T CC LTDA.',
  '081': '081 - BANCOSEGURO S.A.',
  '082': '082 - BANCO TOPÁZIO S.A.',
  '083': '083 - BCO DA CHINA BRASIL S.A.',
  '084': '084 - UNIPRIME NORTE DO PARANÁ - CC',
  '085': '085 - COOP CENTRAL AILOS',
  '089': '089 - CCR REG MOGIANA',
  '091': '091 - CCCM UNICRED CENTRAL RS',
  '092': '092 - BRK S.A. CFI',
  '093': '093 - PÓLOCRED SCMEPP LTDA.',
  '094': '094 - BANCO FINAXIS',
  '095': '095 - TRAVELEX BANCO DE CÂMBIO S.A.',
  '096': '096 - BCO B3 S.A.',
  '097': '097 - CREDISIS CENTRAL DE COOPERATIVAS DE CRÉDITO LTDA.',
  '098': '098 - CREDIALIANÇA CCR',
  '099': '099 - UNIPRIME CENTRAL CCC LTDA.',
  100: '100 - PLANNER CV S.A.',
  101: '101 - RENASCENCA DTVM LTDA',
  102: '102 - XP INVESTIMENTOS CCTVM S/A',
  104: '104 - CAIXA ECONOMICA FEDERAL',
  105: '105 - LECCA CFI S.A.',
  107: '107 - BCO BOCOM BBM S.A.',
  108: '108 - PORTOCRED S.A. - CFI',
  111: '111 - OLIVEIRA TRUST DTVM S.A.',
  113: '113 - MAGLIANO S.A. CCVM',
  114: '114 - CENTRAL COOPERATIVA DE CRÉDITO NO ESTADO DO ESPÍRITO SANTO',
  117: '117 - ADVANCED CC LTDA',
  118: '118 - STANDARD CHARTERED BI S.A.',
  119: '119 - BCO WESTERN UNION',
  120: '120 - BCO RODOBENS S.A.',
  121: '121 - BCO AGIBANK S.A.',
  122: '122 - BCO BRADESCO BERJ S.A.',
  124: '124 - BCO WOORI BANK DO BRASIL S.A.',
  125: '125 - PLURAL BCO BM',
  126: '126 - BR PARTNERS BI',
  127: '127 - CODEPE CVC S.A.',
  128: '128 - MS BANK S.A. BCO DE CÂMBIO',
  129: '129 - UBS BRASIL BI S.A.',
  130: '130 - CARUANA SCFI',
  131: '131 - TULLETT PREBON BRASIL CVC LTDA',
  132: '132 - ICBC DO BRASIL BM S.A.',
  133: '133 - CRESOL CONFEDERAÇÃO',
  134: '134 - BGC LIQUIDEZ DTVM LTDA',
  136: '136 - UNICRED',
  138: '138 - GET MONEY CC LTDA',
  139: '139 - INTESA SANPAOLO BRASIL S.A. BM',
  140: '140 - EASYNVEST - TÍTULO CV SA',
  142: '142 - BROKER BRASIL CC LTDA.',
  143: '143 - TREVISO CC S.A.',
  144: '144 - BEXS BCO DE CAMBIO S.A.',
  145: '145 - LEVYCAM CCV LTDA',
  146: '146 - GUITTA CC LTDA',
  149: '149 - FACTA S.A. CFI',
  157: '157 - ICAP DO BRASIL CTVM LTDA.',
  159: '159 - CASA CREDITO S.A. SCM',
  163: '163 - COMMERZBANK BRASIL S.A. - BCO MÚLTIPLO',
  169: '169 - BCO OLÉ BONSUCESSO CONSIGNADO S.A.',
  173: '173 - BRL TRUST DTVM SA',
  174: '174 - PERNAMBUCANAS FINANC S.A. CFI',
  177: '177 - GUIDE',
  180: '180 - CM CAPITAL MARKETS CCTVM LTDA',
  182: '182 - DACASA FINANCEIRA S/A - SCFI',
  183: '183 - SOCRED SA - SCMEPP',
  184: '184 - BCO ITAÚ BBA S.A.',
  188: '188 - ATIVA S.A. INVESTIMENTOS CCTVM',
  189: '189 - HS FINANCEIRA',
  190: '190 - SERVICOOP',
  191: '191 - NOVA FUTURA CTVM LTDA.',
  194: '194 - PARMETAL DTVM LTDA',
  196: '196 - FAIR CC S.A.',
  197: '197 - STONE PAGAMENTOS S.A.',
  208: '208 - BANCO BTG PACTUAL S.A.',
  212: '212 - BANCO ORIGINAL',
  213: '213 - BCO ARBI S.A.',
  217: '217 - BANCO JOHN DEERE S.A.',
  218: '218 - BCO BS2 S.A.',
  222: '222 - BCO CRÉDIT AGRICOLE BR S.A.',
  224: '224 - BCO FIBRA S.A.',
  233: '233 - BANCO CIFRA',
  237: '237 - BCO BRADESCO S.A.',
  241: '241 - BCO CLASSICO S.A.',
  243: '243 - BCO MÁXIMA S.A.',
  246: '246 - BCO ABC BRASIL S.A.',
  249: '249 - BANCO INVESTCRED UNIBANCO S.A.',
  250: '250 - BCV',
  253: '253 - BEXS CC S.A.',
  254: '254 - PARANA BCO S.A.',
  260: '260 - NU PAGAMENTOS S.A.',
  265: '265 - BCO FATOR S.A.',
  266: '266 - BCO CEDULA S.A.',
  268: '268 - BARI CIA HIPOTECÁRIA',
  269: '269 - HSBC BANCO DE INVESTIMENTO',
  270: '270 - SAGITUR CC LTDA',
  271: '271 - IB CCTVM S.A.',
  272: '272 - AGK CC S.A.',
  273: '273 - CCR DE SÃO MIGUEL DO OESTE',
  274: '274 - MONEY PLUS SCMEPP LTDA',
  276: '276 - SENFF S.A. - CFI',
  278: '278 - GENIAL INVESTIMENTOS CVM S.A.',
  279: '279 - CCR DE PRIMAVERA DO LESTE',
  280: '280 - AVISTA S.A. CFI',
  281: '281 - CCR COOPAVEL',
  283: '283 - RB CAPITAL INVESTIMENTOS DTVM LTDA.',
  285: '285 - FRENTE CC LTDA.',
  286: '286 - CCR DE OURO',
  288: '288 - CAROL DTVM LTDA.',
  289: '289 - DECYSEO CC LTDA.',
  290: '290 - PAGSEGURO',
  292: '292 - BS2 DTVM S.A.',
  293: '293 - LASTRO RDV DTVM LTDA',
  296: '296 - VISION S.A. CC',
  298: '298 - VIPS CC LTDA.',
  299: '299 - SOROCRED CFI S.A.',
  300: '300 - BCO LA NACION ARGENTINA',
  301: '301 - BPP IP S.A.',
  306: '306 - PORTOPAR DTVM LTDA',
  307: '307 - TERRA INVESTIMENTOS DTVM',
  309: '309 - CAMBIONET CC LTDA',
  310: '310 - VORTX DTVM LTDA.',
  315: '315 - PI DTVM S.A.',
  318: '318 - BCO BMG S.A.',
  319: '319 - OM DTVM LTDA',
  320: '320 - BCO CCB BRASIL S.A.',
  321: '321 - CREFAZ SCMEPP LTDA',
  322: '322 - CCR DE ABELARDO LUZ',
  323: '323 - MERCADO PAGO',
  325: '325 - ÓRAMA DTVM S.A.',
  329: '329 - QI SCD S.A.',
  330: '330 - BANCO BARI S.A.',
  331: '331 - FRAM CAPITAL DTVM S.A.',
  332: '332 - ACESSO',
  335: '335 - BANCO DIGIO',
  336: '336 - BCO C6 S.A.',
  340: '340 - SUPER PAGAMENTOS E ADMINISTRACAO DE MEIOS ELETRONICOS S.A.',
  341: '341 - ITAÚ UNIBANCO S.A.',
  342: '342 - CREDITAS SCD',
  343: '343 - FFA SCMEPP LTDA.',
  348: '348 - BCO XP S.A.',
  349: '349 - AMAGGI S.A. CFI',
  352: '352 - TORO CTVM LTDA',
  354: '354 - NECTON INVESTIMENTOS S.A CVM',
  355: '355 - ÓTIMO SCD S.A.',
  364: '364 - GERENCIANET PAGAMENTOS DO BRASIL LTDA',
  366: '366 - BCO SOCIETE GENERALE BRASIL',
  370: '370 - BCO MIZUHO S.A.',
  376: '376 - BCO J.P. MORGAN S.A.',
  380: '380 - PICPAY SERVICOS S.A.',
  383: '383 - JUNO',
  389: '389 - BCO MERCANTIL DO BRASIL S.A.',
  394: '394 - BCO BRADESCO FINANC. S.A.',
  399: '399 - KIRTON BANK',
  403: '403 - CORA CDS S.A.',
  412: '412 - BCO CAPITAL S.A.',
  422: '422 - BCO SAFRA S.A.',
  456: '456 - BCO MUFG BRASIL S.A.',
  461: '461 - Asaas I.P S.A',
  464: '464 - BCO SUMITOMO MITSUI BRASIL S.A.',
  473: '473 - BCO CAIXA GERAL BRASIL S.A.',
  477: '477 - CITIBANK N.A.',
  479: '479 - BCO ITAUBANK S.A.',
  487: '487 - DEUTSCHE BANK S.A.BCO ALEMAO',
  488: '488 - JPMORGAN CHASE BANK',
  492: '492 - ING BANK N.V.',
  495: '495 - BCO LA PROVINCIA B AIRES BCE',
  505: '505 - BCO CREDIT SUISSE S.A.',
  536: '536 - NEON PAGAMENTOS S.A. IP',
  545: '545 - SENSO CCVM S.A.',
  600: '600 - BCO LUSO BRASILEIRO S.A.',
  604: '604 - BCO INDUSTRIAL DO BRASIL S.A.',
  610: '610 - BCO VR S.A.',
  611: '611 - BCO PAULISTA S.A.',
  612: '612 - BCO GUANABARA S.A.',
  613: '613 - OMNI BANCO S.A.',
  623: '623 - BANCO PAN',
  626: '626 - BCO FICSA S.A.',
  630: '630 - SMARTBANK',
  633: '633 - BCO RENDIMENTO S.A.',
  634: '634 - BCO TRIANGULO S.A.',
  637: '637 - BCO SOFISA S.A.',
  643: '643 - BCO PINE S.A.',
  652: '652 - ITAÚ UNIBANCO HOLDING S.A.',
  653: '653 - BCO INDUSVAL S.A.',
  654: '654 - BCO A.J. RENNER S.A.',
  655: '655 - BCO VOTORANTIM S.A.',
  707: '707 - BCO DAYCOVAL S.A',
  712: '712 - BCO OURINVEST S.A.',
  739: '739 - BCO CETELEM S.A.',
  741: '741 - BCO RIBEIRAO PRETO S.A.',
  743: '743 - BANCO SEMEAR',
  745: '745 - BCO CITIBANK S.A.',
  746: '746 - BCO MODAL S.A.',
  747: '747 - BCO RABOBANK INTL BRASIL S.A.',
  748: '748 - BCO COOPERATIVO SICREDI S.A.',
  751: '751 - SCOTIABANK BRASIL',
  752: '752 - BCO BNP PARIBAS BRASIL S A',
  753: '753 - NOVO BCO CONTINENTAL S.A. - BM',
  754: '754 - BANCO SISTEMA',
  755: '755 - BOFA MERRILL LYNCH BM S.A.',
  756: '756 - BANCOOB',
  757: '757 - BCO KEB HANA DO BRASIL S.A.'
}

export { BANKS_ENUM }
export default BANKS_ENUM
